<template>
  <div class="page">
    <el-button
      type="primary"
      plain
      class="addBtn"
      size="small"
      v-if="deathInfo == null&&$buttonAuthority('huoti-zongcang-adddeath')"
      @click="drawer = true"
      >添加死亡记录</el-button
    >
    <div class="comView" v-if="deathInfo != null">
      <div class="comName">
        <div>
          亡故日期:{{ $public.FTime(deathInfo.deathTime, "YYYY-MM-DD") }}
        </div>
        <div>
          添加日期:{{
            deathInfo.createDeathRecordTime == null
              ? "--"
              : $public.FTime(
                  deathInfo.createDeathRecordTime,
                  "YYYY-MM-DD HH:mm:ss"
                )
          }}
        </div>
        <div>
          添加人:{{
            deathInfo.createDeathRecordUser == null
              ? "--"
              : deathInfo.createDeathRecordUser
          }}
        </div>
      </div>
      <div class="comTitle">图片:</div>
      <div class="comImg">
        <el-image
          style="width: 56px; height: 56px; margin-right: 10px"
          :src="item"
          fit="cover"
          v-for="(item, index) in deathInfo.deathImgs"
          :key="index"
          :preview-src-list="deathInfo.deathImgs"
        ></el-image>
      </div>
      <div class="deathRemark">亡故说明:{{ deathInfo.remark }}</div>
    </div>
    <!-- 添加亡故记录 -->
    <el-drawer
      title="添加亡故记录"
      :modal="false"
      size="30%"
      :visible.sync="drawer"
      custom-class="drawersend"
      direction="rtl"
    >
      <div class="sx">
        <div class="sxMsg">
          <div class="line"></div>
          <div class="comWrap">
            <div class="draDate">
              <div class="draName">亡故日期：</div>
              <el-date-picker
                v-model="deathTime"
                type="date"
                placeholder="选择日期"
                size="small"
                style="width: 130px"
              >
              </el-date-picker>
            </div>
            <div class="draCom">
              <div class="draName">图片：</div>
              <div class="imgView">
                <div
                  v-for="(item, index) in detailImgList"
                  :key="index"
                  class="imgItem"
                >
                  <img
                    alt=""
                    :src="item"
                    v-if="detailImgList.length > 0"
                    style="border-radius: 6px"
                  />
                  <i
                    class="el-icon-error closeBtn"
                    v-if="detailImgList.length > 0"
                    @click="handleDeleteImgClick(index)"
                  ></i>
                </div>
                <i
                  class="el-icon-plus avatar-uploader-icon"
                  style="border: 1px dashed #d9d9d9; border-radius: 6px"
                  @click="handleUploadDetailClick"
                  v-if="detailImgList.length < 9"
                ></i>
                <input
                  type="file"
                  ref="fileDetail"
                  style="width: 0; height: 0"
                  @change="changeDetailFile"
                />
              </div>
            </div>
            <div class="draRemark">
              <div class="draName">亡故说明：</div>
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入内容"
                v-model="remark"
                resize="none"
                style="flex: 1"
                size="small"
              >
              </el-input>
            </div>
          </div>
        </div>
        <div class="sxBtn">
          <div @click="canelClick">取消</div>
          <div @click="handelCertainClick">确定</div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { deathInfo, addDeath } from "@/api/purchaseApi.js";
export default {
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      deathInfo: null,
      drawer: false,
      deathTime: "", //死亡日期
      detailImgList: [], //图片
      remark: "",
    };
  },
  mounted() {
    this.getDeathInfo();
  },
  methods: {
    handleUploadDetailClick() {
      this.$refs.fileDetail.click();
    },
    //上传图片
    changeDetailFile(e) {
      var index = e.target.files[0].name.lastIndexOf(".");
      var ext1 = e.target.files[0].name.substr(index + 1);
      var formData = new FormData();
      var ext = ext1.toLowerCase();
      if (ext === "png" || ext === "jpg" || ext === "jpeg") {
        formData.append("img", e.target.files[0]);
        this.$util
          .uploadImg_dir(formData, { dir: "uploadImg" })
          .then((data) => {
            if (data.timestamp) {
              this.detailImgList.push(data.url);
            }
          });
      } else {
        this.$message({
          message: "只能上传jpg,jpeg,png格式的文件",
          type: "error",
        });
        return;
      }
      // this.$refs.file.value = null
    },
    //删除对应图片
    handleDeleteImgClick(index) {
      this.detailImgList.splice(index, 1);
    },
    //弹框确认
    handelCertainClick() {
      if (this.deathTime == "") {
        this.$message({
          type: "error",
          message: "请选择亡故日期",
        });
        return;
      }
      if (this.detailImgList.length == 0) {
        this.$message({
          type: "error",
          message: "请选择图片",
        });
        return;
      }
      if (this.remark == "") {
        this.$message({
          type: "error",
          message: "请填写亡故说明",
        });
        return;
      }
      console.log(this.detailImgList);
      let imgs = "";
      for (let i = 0; i < this.detailImgList.length; i++) {
        imgs = imgs + this.detailImgList[i] + ",";
      }
      let params = {
        petId: this.id,
        deathTime: new Date(this.deathTime).getTime() / 1000,
        remark: this.remark,
        imgs: imgs,
      };
      console.log(params);
      this.drawer = false;

      addDeath(params).then((res) => {
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.getDeathInfo();
          this.$emit("reset");
        }else{
          this.$message({
            type: "error",
            message: "添加失败",
          });
        }
      });
    },
    //弹框取消按钮
    canelClick() {
      this.drawer = false;
      this.remark = "";
      this.deathTime = "";
      this.detailImgList = [];
    },
    getDeathInfo() {
      let params = {
        petId: this.id,
      };
      deathInfo(params).then((res) => {
        console.log("死亡信息", res);
        if (res.code == 0) {
          this.deathInfo = res.data;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  min-height: 734px;
  background: #fff;
  margin-top: 12px;
  font-size: 14px;
  position: relative;

  .addBtn {
    position: absolute;
    right: 12px;
    top: 12px;
  }

  .comView {
    padding: 18px 16px;

    .comName {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      div {
        width: 240px;
        margin-right: 10px;
      }
    }

    .comTitle {
      margin-bottom: 16px;
    }

    .comImg {
      display: flex;
      margin-bottom: 16px;
    }
  }

  .line {
    width: 100%;
    height: 1px;
    background: #f2f2f2;
  }

  .sx {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .comWrap {
      padding: 20px;
      font-size: 12px;
      color: #666;
      line-height: 20px;

      .draDate {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
      }
      .draRemark {
        display: flex;
        margin-top: 20px;
      }
      .draCom {
        display: flex;

        .avatar-uploader .el-upload {
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        .avatar-uploader .el-upload:hover {
          border-color: #409eff;
        }

        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 56px;
          height: 56px;
          line-height: 56px;
          text-align: center;
        }

        .avatar {
          width: 56px;
          height: 56px;
          display: block;
          object-fit: cover;
        }
      }
    }

    .imgView {
      flex: 1;

      .imgItem {
        position: relative;
        width: 56px;
        height: 56px;
        margin-right: 20px;
        margin-bottom: 20px;
        float: left;

        img {
          width: 100%;
          height: 100%;
        }

        .closeBtn {
          width: 20px;
          height: 20px;
          display: block;
          color: red;
          position: absolute;
          top: -10px;
          right: -10px;
          font-size: 20px;
          z-index: 5;
        }
      }
    }

    .sxBtn {
      height: 40px;
      display: flex;
      cursor: pointer;
      font-size: 14px;
      color: #fff;
      line-height: 40px;
      text-align: center;

      div:nth-of-type(1) {
        flex: 1;
        background: #e1e9fb;
        color: #467eff;
      }

      div:nth-of-type(2) {
        flex: 1;
        background: #467eff;
      }
    }
  }
}
</style>
